import {parseResponse} from '../../../helpers/api'
import client from '../../../client'
import {extractFileName} from '../../../helpers/file'

export default {
    async getMissingSamples() {
        return client.v1.get(`/samples/get-missing`, {
            params: {}
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async moveSampleToArchive(sampleId) {
        return client.v1.post(`/samples/move-to-archive`, {
            id: sampleId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async moveSampleToSuitableBatch(sampleId) {
        return client.v1.post(`/batches/move-sample-to-suitable-batch`, {
            id: sampleId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async getBatch(id) {
        return client.v1.get(`/batches/get`, {
            params: {
                id: id
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async getBatches(skip, limit, filters) {
        return client.v1.get(`/batches/get-list`, {
            params: {
                skip: skip,
                limit: limit,
                filters: filters
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async getAllBatches() {
        return client.v1.get(`/batches/all`, {
            params: {
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async createBatch(batchData) {
        return client.v1.post(`/batches/create`, {
            ...batchData
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async getSampleBatchList(batchId) {
        return client.v1.get(`/batches/get-samples`, {
            params: {
                id: batchId
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async searchCase(searchString) {
        return client.v1.get(`/batches/search-case`, {
            params: {
                systemId: searchString
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async search(searchString) {
        return client.v1.get(`/batches/search`, {
            params: {
                searchString: searchString
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async getCasesWithMissingSamples() {
        return client.v1.get(`/batches/get-cases-with-missing-samples`, {}).then((response) => {
            return parseResponse(response)
        })
    },
    async addSample(sampleId, batchId, position) {
        return client.v1.post(`/batches/add-sample`, {
            sampleId: sampleId,
            batchId: batchId,
            position: position
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async updateSample(id, sampleId, position) {
        return client.v1.post(`/batches/update-sample`, {
            id: id,
            sampleId: sampleId,
            position: position
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async removeSample(sampleId, batchId) {
        return client.v1.post(`/batches/remove-sample`, {
            sampleId: sampleId,
            batchId: batchId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async shiftSamplesToLeft(sampleBatchId) {
        return client.v1.post(`/batches/shift-samples-to-left`, {
            startSampleBatchId: sampleBatchId,
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async shiftSamplesToRight(sampleBatchId) {
        return client.v1.post(`/batches/shift-samples-to-right`, {
            startSampleBatchId: sampleBatchId,
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async startBatchProcessing(batchId, responsibleSpecialistId) {
        return client.v1.post(`/batches/start-processing`, {
            id: batchId,
            responsibleSpecialistId: responsibleSpecialistId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async printLabels(batchId) {
        return client.v1.post(`/batches/print-labels`, {
            id: batchId,
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async exportBatchToCsv(id) {
        return client.v1.get(`/batches/export-to-csv`, {
            params: {
                id: id
            },
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'text/csv'
            }
        }).then((response) => {
            return response.data
        })
    },
    async exportBatchSamplesToXlsx(id) {
        return client.v1.get(`/batches/export-samples-to-xlsx`, {
            params: {
                id: id
            },
            responseType: 'arraybuffer'
        }).then((response) => {
            const fileName = extractFileName(response)
            return {
                data: response.data,
                fileName: fileName
            }
        })
    },
    async addFileToBatch(batchId, fileId) {
        let response = null
        try {
            response = await client.v1.post(`/batches/add-file`, {
                batchId: batchId,
                fileId: fileId
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },
    async deleteFileFromBatch(batchId, fileId) {
        let response = null
        try {
            response = await client.v1.post(`/batches/delete-file`, {
                batchId: batchId,
                fileId: fileId
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    },

}